import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged, signOut, GoogleAuthProvider, signInWithPopup, type User } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// Your web app's Firebase configuration.
export const firebaseConfig =  {
  // =================================================================
  //  ACTION REQUIRED: Replace the values below with the config 
  //  from your NEW Firebase project.
  //
  //  FIND IT HERE:
  //  1. Go to Firebase Console > Project Settings.
  //  2. Scroll to "Your apps" > SDK setup and configuration.
  //  3. Copy the values from the firebaseConfig object.
  // =================================================================
  apiKey: "AIzaSyB0SEb5upNwwQ9XEulLAn4NKWX1uGJQVbk",
  authDomain: "edugravity.app",
  projectId: "edugravity-11b47",
  storageBucket: "edugravity-11b47.firebasestorage.app",
  messagingSenderId: "677923663366",
  appId: "1:677923663366:web:c95aaf6ee8f4f1a0981d87"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize and export services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Re-export auth functions for consistency
export { onAuthStateChanged, signOut, GoogleAuthProvider, signInWithPopup };

// Export User type
export type { User };